import { lazy } from "react";
const Login = lazy(() => import("../components/login"));
const Register = lazy(() => import("../components/register"));
const Thankyou = lazy(() => import("../components/page.thankyou"));
const Verify = lazy(() => import("../components/verify"));
const PWForgot = lazy(() => import("../components/pw-forgot"));
const PWReset = lazy(() => import("../components/pw-reset"));
const DeleteAccount = lazy(
  () => import("../pages/deleteAccount/deleteAccount"),
);
const DeleteAccountThankyou = lazy(
  () => import("../pages/deleteAccountThankyou/thankyou"),
);

const authRoutes = [
  {
    path: "/auth/login",
    component: Login,
    title: "Login | Delete My Info",
    description:
      "Access your account by logging in. Enjoy a secure, seamless, and personalized experience at Delete My Info.",
  },
  {
    path: "/auth/gift/register/:id",
    component: Register,
    title: "Gift Register | Delete My Info",
    description:
      "Create and manage your gift registry with ease at Delete My Info.",
  },
  {
    path: "/auth/thankyou",
    component: Thankyou,
    title: "Thank You | Delete My Info",
    description:
      "Thank you for your subscription! We appreciate your support and look forward to serving you again at Delete My Info.",
  },
  {
    path: "/auth/pw-reset/:id",
    component: PWReset,
    title: "Reset Password | Delete My Info",
    description: "Securely reset your password at Delete My Info.",
  },
  {
    path: "/auth/pw-forgot",
    component: PWForgot,
    title: "Forgot Password | Delete My Info",
    description:
      "Can't remember your password? Reset it easily and securely at Delete My Info to regain access to your account.",
  },
  {
    path: "/auth/verify/:id",
    component: Verify,
    title: "Verify Your Account | Delete My Info",
    description:
      "Verify your account to complete your registration and enjoy full access to Delete My Info. Check your email for the verification link.",
  },
  {
    path: "/auth/delete-account",
    component: DeleteAccount,
    title: "Delete Account | Delete My Info",
    description:
      "Permanently delete your account at Delete My Info. Confirm your decision to remove your account securely.",
  },
  {
    path: "/auth/delete-account-thankyou",
    component: DeleteAccountThankyou,
    title: "Account Deletion Confirmed | Delete My Info",
    description:
      "Your account has been successfully deleted. Thank you for your time with Delete My Info. We hope to see you again in the future.",
  },
];
export default authRoutes;
